/*
 *   File : reports.js
 *   Author URI : https://evoqueinnovativelab.com
 *   Version : v1.0
*/

import { Fragment, useEffect, useState } from "react";
import styles from '../../styles/components/accordionUserInvestment.module.scss';
import { PrimaryBtn } from "../../components/cta";
import { DateRangePicker, Datepicker } from "../../components/input";
import { data } from "jquery";
import APIPost from "../../services/postApi";
import { Toast } from "../../components/note";
import devconfig from "../../config/config";
import moment from "moment";


const REPORT_DATA = [
    {
        label: "Holdings Report",
        id: 1
    },
    {
        label: "Transactions Report",
        id: 2
    },
    {
        label: "Capital Gain Report",
        id: 3
    }
]

const ManageReports = (props) => {
    const [reportSelected, setReportSelected] = useState(null);
    const [dates, setDates] = useState({
        start: null,
        end: null
    });
    const [apiLoader, setApiLoader] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);
    const [asOnDate, setAsonDate] = useState(null);

    useEffect(() => {
        if (error !== null) {
            setTimeout(() => {
                setError(null)
            }, 3000)
        }
    }, [error])

    useEffect(() => {
        if (success !== null) {
            setTimeout(() => {
                setSuccess(null)
            }, 3000)
        }
    }, [success])

    // API - Download reports
    const _downloadReport = () => {
        console.log('asOnDate', asOnDate);
        setApiLoader(true);
        const url = reportSelected === 1 ? devconfig.admin + "/reports/holdings-report" : reportSelected === 2 ? devconfig.admin + "/reports/transaction-report" : devconfig.admin + "/reports/capitalgain-report";
        const data =
            reportSelected !== 1 ?
                JSON.stringify({
                    "from_date": dates.start !== null ? moment(dates.start).format("YYYY-MM-DD") : null,
                    "end_date": dates.end !== null ? moment(dates.end).format("YYYY-MM-DD") : null,
                    "customer_id": props.id
                })
                :
                JSON.stringify({
                    "as_on_date": asOnDate !== null ? moment(asOnDate, "DD-MM-YYYY").format("YYYY-MM-DD") : null,
                    "customer_id": props.id
                })
        APIPost(url, data).then((response) => {
            if (response.status_code === 200) {
                if (response.data.url !== null) {
                    window.open(response.data.url, "_blank");
                    setSuccess("Report downloaded successfully");
                }else{
                    setError("No reports found");
                }
                
            } else {
                setError(response.message);
            }
            setApiLoader(false);
        });
    };

        const disabledDate = (current) => {
            if (current.isAfter(moment().subtract(1, "days"))) {
                return true
            }
        }
    return (
        <div className="row pe-0">
            <div className="col-lg-12 pe-0">
                <div className="card e-dashboard-card border-0">
                    <div className={`${styles.e_user_accordion}  `}>
                        {
                            REPORT_DATA.map((item) => {
                                return (
                                    <div className={`${styles.e_accordion_sec} `}>
                                        <div className={`${styles.e_accordion_button} cursor-pointer pt-3`} >

                                            <div className="row align-items-start" onClick={() => {
                                                if (item.id !== reportSelected) {
                                                    setReportSelected(item.id);
                                                    setDates({
                                                        start: null,
                                                        end: null
                                                    })
                                                } else {
                                                    setReportSelected(null);
                                                }
                                            }}>
                                                <div className="col-lg-10" >
                                                    <span className={`${styles.e_accordion_title}`}>{item.label}</span>

                                                </div>
                                                <div className="col-lg-2" >
                                                    {reportSelected !== item.id ? <span className={`${styles.e_accordion_icon}`} ></span> : <span className={`${styles.e_accordion_icon_minus}`} style={{ top: 'auto' }}></span>}
                                                </div>
                                            </div>
                                            {
                                                reportSelected === item.id ?
                                                    <div className="row pt-3">
                                                        {
                                                            item.id === 1 ?
                                                                <>
                                                                    <div className="col-lg-3 mb-3">
                                                                        <label>As on Date</label>
                                                                        <Datepicker
                                                                            value={asOnDate}
                                                                            disabledDate={disabledDate}
                                                                            onChange={(value) => {
                                                                                setAsonDate(value)
                                                                            }}
                                                                        />
                                                                    </div>
                                                                    <div className="col-12">
                                                                        <PrimaryBtn name="Download"
                                                                            className={apiLoader ? "e-btn-loader" : ""}
                                                                            handleClick={_downloadReport} />
                                                                    </div>
                                                                </>
                                                                :

                                                                <Fragment>
                                                                    <div className="col-lg-3">
                                                                        <DateRangePicker start={dates.start}
                                                                            end={dates.end}
                                                                            onDatesChange={(start, end) => {
                                                                                setDates({ start: start, end: end });
                                                                            }} />
                                                                    </div>
                                                                    <div className="col-lg-2">
                                                                        <PrimaryBtn name="Download"
                                                                            className={apiLoader ? "e-btn-loader" : ""}
                                                                            handleClick={_downloadReport} />
                                                                    </div>
                                                                </Fragment>
                                                        }
                                                    </div>
                                                    :
                                                    null
                                            }
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            </div>
            {/* Error toast */}
            {
                error !== null ?
                    <Toast data={error}
                        type="error"
                        id="1" />
                    :
                    null
            }

            {/* Success toast */}
            {
                success !== null ?
                    <Toast data={success}
                        type="success"
                        id="2" />
                    :
                    null
            }
        </div>
    )
}

export default ManageReports